<script lang="ts">
  import EditGoalStatus from "$app/Pages/Plans/Goals/EditGoalStatus.svelte"
  import Progress from "./Progress.svelte"
  import Form from "$app/Pages/Plans/Goals/Progress/Form.svelte"
  import { MessageSquareText } from "lucide-svelte"
  import { trim } from "$app/utils"
  import { appStore } from "$app/store.svelte"

  let props = $props()
  let {
    task,
    pos
  }: {
    task: TaskType
    pos: number
  } = props

  function withinDates(date: string): boolean {
    const d = new Date(date)
    return (
      appStore.dateStart.getTime() <= d.getTime() &&
      d.getTime() <= appStore.dateEnd.getTime()
    )
  }

  let newProgress = $state(false)

  let assignee = $state(null)
  if (task.assignee_type === "User") {
    assignee = appStore.users[task.assignee_id]
  }
</script>

<div class="border-l-4 border-task shadow-md mb-4 task">
  <div class="border-b border-gray-200">
    <div class="border-t border-gray-200 py-1 px-4 relative">
      <div class="grid grid-cols-8 gap-1">
        <div
          class="col-span-4 font-semibold flex items-center relative text-sm lg:text-base text-gray-800"
        >
          <span class="text-gray-400 text-sm mr-1">{pos}.</span>
          {task.name}
          {#if withinDates(task.created_at)}
            <div
              class="absolute top-1 right-2 rounded px-1 text-xs bg-red-500 text-white font-semibold"
            >
              NEW
            </div>
          {/if}
        </div>

        <div
          class="hidden lg:inline-flex lg:col-span-2 flex justify-center items-center"
        >
          {#if assignee}
            <span class="bg-gray-100 px-2 py-0.5 rounded text-xs text-gray-600">
              {trim(assignee?.name)}
            </span>
          {/if}
        </div>

        <div class="col-span-4 lg:col-span-2 flex justify-end items-center">
          {#if !newProgress}
            <button
              class="mr-6"
              class:text-red-500={task.progresses.length === 0}
              class:text-blue-500={task.progresses.length > 0}
              onclick={() => {
                newProgress = true
              }}
            >
              <MessageSquareText class="size-5" />
            </button>
          {/if}
          <EditGoalStatus
            goalOrTask={task}
            type="Task"
            editable={true}
            small={true}
            show_border={false}
          />
        </div>
      </div>
    </div>
  </div>

  {#if task.progresses?.length || newProgress}
    <div class="py-2 px-4">
      {#if newProgress}
        <Form
          progress={{ plan_id: appStore.plan.id, [`task_id`]: task.id }}
          type="task"
          operation="create"
          oncreate={(detail) => {
            task.progresses = [detail, ...task.progresses]
            newProgress = false
          }}
          oncancel={() => {
            newProgress = false
          }}
        />
      {:else}
        {#each task.progresses as progress}
          <div class="shadow-sm">
            <Progress {progress} clazz="bg-yellow-100 bg-opacity-25" />
          </div>
        {/each}
      {/if}
    </div>
  {/if}
</div>
